import { Client } from '@microsoft/microsoft-graph-client';
import { GRAPH_CLIENT_MIDDLEWARE_OPTIONS } from './GraphClientMiddlewareOptions'
import { LogEvents } from '../../utils/LogEvents';
import { ErrorStringFromException } from '../../utils/utils';
import { RetryServiceCallUntilSuccessOrTimeout } from '../Utils';

async function MakeGraphGetRequest(graphClient: Client, path: string) {
    return RetryServiceCallUntilSuccessOrTimeout(LogEvents.ServiceGraphOneDriveItem, 
        () =>
            graphClient.api(path)
            .middlewareOptions(GRAPH_CLIENT_MIDDLEWARE_OPTIONS)
            .get(),
        false /*shouldRetryOnNull*/,
        (e) => e.code == 'TypeError' && e.statusCode == -1 /*shouldRetryError*/); // Only retry when we receive a fetch TypeError (which implies a network error).
}

export async function MakeOneDriveItemGraphRequest(graphClient: Client, driveId: string, itemId: string) {
    LogEvents.ServiceGraphOneDriveItem.Start();
    try {
        const response = await MakeGraphGetRequest(graphClient, `/drives/${driveId}/items/${itemId}`);
        const message: string = (response == null)? "Error: response was null" : "Successfully received a response";
        LogEvents.ServiceGraphOneDriveItem.AddResponse({ isSuccessful: response != null, message: message, isFinalResponse: true });
        return response;
    } catch (e) {
        LogEvents.ServiceGraphOneDriveItem.AddResponse({ isSuccessful: false, message: "Error: " + ErrorStringFromException(e), isFinalResponse: true });
        throw e;
    }
}